/* eslint-disable no-bitwise */
import {EventEmitter} from 'events';
import {errorDismissTime, messageDismissTime} from '../../../constants/defaultValues';

const createUUID = () => {
  const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const Constants = {
  CHANGE: 'change',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

const sentenceEnders = ['.', '?', '!'];

class NotificationManager extends EventEmitter {
  constructor() {
    super();
    this.listNotify = [];
  }

  create(notify) {
    const defaultNotify = {
      id: createUUID(),
      type: 'info',
      title: null,
      message: null,
      timeOut: 5000,
      customClassName: '',
      persistBetweenNavigation: false,
    };

    const notification = Object.assign(defaultNotify, notify);
    const {message} = notification;

    if (message && !sentenceEnders.includes(message[message.length - 1])) {
      notification.message += '.';
    }

    if (notify.priority) {
      this.listNotify.unshift(notification);
    } else {
      this.listNotify.push(notification);
    }
    this.emitChange();
  }

  clearNotifications() {
    const newListNotify = [];
    this.listNotify.forEach(list => {
      if (list.persistBetweenNavigation) {
        newListNotify.push(list);
      }
    });
    this.listNotify = newListNotify;
    this.emitChange();
  }

  primary(message, title, timeOut, onClick, priority, customClassName, persistBetweenNavigation) {
    this.create({
      type: Constants.PRIMARY,
      message,
      title,
      timeOut,
      onClick,
      priority,
      customClassName,
      persistBetweenNavigation,
    });
  }

  secondary(message, title, timeOut, onClick, priority, customClassName, persistBetweenNavigation) {
    this.create({
      type: Constants.SECONDARY,
      message,
      title,
      timeOut,
      onClick,
      priority,
      customClassName,
      persistBetweenNavigation,
    });
  }

  info(message, title, timeOut, onClick, priority, customClassName, persistBetweenNavigation) {
    this.create({
      type: Constants.INFO,
      message,
      title,
      timeOut,
      onClick,
      priority,
      customClassName,
      persistBetweenNavigation,
    });
  }

  success(
    message,
    title,
    timeOut = messageDismissTime,
    onClick,
    priority,
    customClassName,
    persistBetweenNavigation,
  ) {
    this.create({
      type: Constants.SUCCESS,
      message,
      title,
      timeOut,
      onClick,
      priority,
      customClassName,
      persistBetweenNavigation,
    });
  }

  warning(message, title, timeOut, onClick, priority, customClassName, persistBetweenNavigation) {
    this.create({
      type: Constants.WARNING,
      message,
      title,
      timeOut,
      onClick,
      priority,
      customClassName,
      persistBetweenNavigation,
    });
  }

  error(
    message,
    title,
    timeOut = errorDismissTime,
    onClick,
    priority,
    customClassName,
    persistBetweenNavigation,
  ) {
    this.create({
      type: Constants.ERROR,
      message,
      title,
      timeOut,
      onClick,
      priority,
      customClassName,
      persistBetweenNavigation,
    });
  }

  persistentError(message, title, timeOut, onClick, priority, customClassName) {
    this.error(message, title, timeOut, onClick, priority, customClassName, true);
  }

  persistentSuccess(message, title, timeOut, onClick, priority, customClassName) {
    this.success(message, title, timeOut, onClick, priority, customClassName, true);
  }

  remove(notification) {
    this.listNotify = this.listNotify.filter(n => notification.id !== n.id);
    this.emitChange();
  }

  emitChange() {
    this.emit(Constants.CHANGE, this.listNotify);
  }

  addChangeListener(callback) {
    this.addListener(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new NotificationManager();
